import { useParams } from "react-router-dom";

export const useFunnelImportPageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
